// extracted by mini-css-extract-plugin
module.exports = {"notfound":"index_notfound-4nNfF"};